import { useLocation } from 'react-router';
import { useSprintDetails } from './use-sprint-details';

export const useAddTaskToSprint = () => {
  const { pathname } = useLocation();
  const { data } = useSprintDetails();
  const { sprintId } = data ?? {};
  const isSprintBoard =
    pathname.includes(`/sprints/${sprintId}`) &&
    !pathname.includes('/add-tasks');

  const { data: sprint } = useSprintDetails();

  return {
    isTaskAddedToSprint: isSprintBoard,
    sprint,
  };
};
